//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiHome,
  mdiAccountTie,
  mdiToolbox,
  mdiFolder,
  mdiInformation,
  mdiAndroidMessages,
} from '@mdi/js';
import TheFooter from '@/components/layout/the-footer.vue';
export default {
  components: {
    TheFooter,
  },
  data() {
    return {
      drawer: false,
      items: [
        {
          icon: mdiHome,
          text: 'Home',
          route: 'index',
        },
        {
          icon: mdiInformation,
          text: 'Blog',
          route: 'blog',
        },
        {
          icon: mdiAccountTie,
          text: 'Resume',
          route: 'resume',
        },
        {
          icon: mdiFolder,
          text: 'Portfolio',
          route: 'portfolio',
        },
        {
          icon: mdiToolbox,
          text: 'Tools',
          route: 'tools',
        },
        {
          icon: mdiAndroidMessages,
          text: 'Contact',
          route: 'contact',
        },
      ],
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const { href: canonical } = i18nHead.link.find(
      ({ hid }) => hid === 'i18n-can',
    );
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
      },
      meta: [
        ...i18nHead.meta,
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: canonical,
        },
      ],
      link: [...i18nHead.link],
    };
  },
  mounted() {
    const vm = this;
    const beforePrint = function () {
      console.log('Functionality to run before printing.');
      vm.drawer = false;
    };
    const afterPrint = function () {
      console.log('Functionality to run after printing');
    };
    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(function (mql) {
        if (mql.matches) {
          beforePrint();
        } else {
          afterPrint();
        }
      });
    }
    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
  },
};
